import React, { useEffect, useState } from "react";
import axios from "axios";
import { SERVER_URL } from "../../config";
import { formatDateTime, normalizeStatus } from "./utils";
import { StatusBadge } from "./Shared";

const UserHistoryModal = ({ open, user, onClose }) => {
    const [history, setHistory] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
        if (open && user) {
            fetchHistory();
        }
    }, [open, user]);

    const fetchHistory = async () => {
        setLoading(true);
        setError("");
        try {
            // Use slNo or user_id to fetch history
            const userId = user.user_id;
            if (!userId) {
                setError("User ID not found");
                setLoading(false);
                return;
            }

            const res = await axios.get(`${SERVER_URL}/Cloud/userHistory.php`, {
                params: { user_id: userId }
            });

            if (res.data.success) {
                setHistory(
                    Array.isArray(res.data.data?.renewal_history)
                        ? res.data.data.renewal_history
                        : []
                );
            } else {
                setError(res.data.message || "Failed to load history.");
                setHistory([]);
            }
        } catch (err) {
            console.error("Error fetching user history:", err);
            setError("Could not load user history.");
            setHistory([]);
        } finally {
            setLoading(false);
        }
    };

    if (!open) return null;

    return (
        <div className="fixed inset-0 z-[80] flex items-center justify-center bg-black/40 backdrop-blur-sm p-4 overflow-y-auto">
            <div className="w-full max-w-4xl max-h-[85vh] overflow-y-auto rounded-xl bg-white border border-slate-200 p-6" style={{ boxShadow: "0 10px 30px rgba(0,0,0,0.15)" }}>
                <div className="flex items-center justify-between mb-4">
                    <h2 className="text-lg font-bold text-slate-800">
                        User History - {user?.company_name || user?.user_name || "User"}
                    </h2>
                    <button onClick={onClose} className="text-slate-400 hover:text-slate-600">✕</button>
                </div>

                {error && (
                    <div className="rounded-lg px-4 py-3 bg-rose-50 border border-rose-200 text-rose-700 text-sm mb-4">
                        {error}
                    </div>
                )}

                {loading ? (
                    <div className="text-center py-8 text-slate-400">Loading history...</div>
                ) : history.length === 0 ? (
                    <div className="text-center py-8 text-slate-400">No history found for this user.</div>
                ) : (
                    <div className="overflow-x-auto">
                        <table className="min-w-full text-sm">
                            <thead style={{ background: "#f8fafc" }}>
                                <tr>
                                    <th className="p-2 text-left text-xs text-slate-500">Date</th>
                                    <th className="p-2 text-left text-xs text-slate-500">Action</th>
                                    <th className="p-2 text-left text-xs text-slate-500">Status</th>
                                    <th className="p-2 text-left text-xs text-slate-500">Reason</th>
                                    <th className="p-2 text-left text-xs text-slate-500">Action By</th>
                                </tr>
                            </thead>
                            <tbody>
                                {history.map((item, index) => (
                                    <tr key={index} className="border-t border-slate-100">
                                        <td className="p-2 text-xs text-slate-600">{formatDateTime(item.created_at)}</td>
                                        <td className="p-2 text-xs text-slate-600 capitalize">{item.action || "—"}</td>
                                        <td className="p-2 text-xs"><StatusBadge status={item.status} /></td>
                                        <td className="p-2 text-xs text-slate-600">{item.reason || "—"}</td>
                                        <td className="p-2 text-xs text-slate-600">{item.action_taken_by || "—"}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    );
};

export default UserHistoryModal;